/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-21 09:49:25
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface PDRecordListParams {
  materialsName?: any
  current?: any
  size?: any
}

export function getPDRecordList(params: PDRecordListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugdestroyrecord/list`,
    method: 'GET',
    params,
  }
}

// 详情
export function getPDRecordDetail(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugdestroyrecord/detail`,
    method: 'GET',
    params: {
      id,
    },
  }
}

// 导出
export function getPDRecordExport(params: PDRecordListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/`,
    method: 'POST',
    responseType: 'blob',
    params,
  }
}

// 保存编辑
export interface SubmitParams {
  id?: any
  destroyAddress?: any
  destroyDate?: any  
  destroyNumber?: any
  destroyReason?: any
  destroyUser?:any
  destroyUserName?: any
  remark?:any
  superviseUser?:any
  superviseUserName?: any
  tenantMaterialsCatalogId?: any
  tenantInventoryLedgerId?: any
  tenantMaterialsName?: any

}

export function getPDRecordSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugdestroyrecord/submit`,
    method: 'POST',
    body,
  }
}


// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugdestroyrecord/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}


// 审核
export function getExamine(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdrugdestroyrecord/examine`,
    method: 'GET',
    params: {
      id,
    },
  }
}